import apiClient from '../apiClient';
import { DELETE_SPECIAL_ADJUSMENT_URL } from '../apiUrl';

const deleteSpecialAdjusmentApi = Id => {
  return apiClient.delete(DELETE_SPECIAL_ADJUSMENT_URL(Id));
};

export default deleteSpecialAdjusmentApi;
